module.exports = __webpack_public_path__ + "img/ic-unionpaycard.4027485a.svg";